@if (shippingState$ | async; as shipping) {
<div class="shipping">
  @if (shipping.loading) {
  <peca-shipping-loader />
  } @else if (shipping.failed) {
  <peca-shipping-failed [failure]="failure" (retry)="onRetryFetch()" />
  } @else if (shipping.data && shipping.data.status === shippingStatusEnum.SEARCHING_CARRIER) {
  <peca-shipping-confirmation [shipping]="shipping.data" (reload)="onReloadShipping()" />
  } @else if (shipping.data && shipping.data.status === shippingStatusEnum.CANCELED || shipping.data && shipping.data.status === shippingStatusEnum.DELIVERED) {
  <peca-shipping-concluded [shipping]="shipping.data" />
  } @else if (shipping.data) {
  <peca-shipping-details [shipping]="shipping.data" (reload)="onReloadShipping()" />
  }
</div>
}
